import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "../../lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-4 py-1.5 text-xs font-semibold transition-smooth focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground hover:bg-primary-dark shadow-sm",
        secondary: "border-transparent bg-secondary/20 text-secondary-foreground border-secondary hover:bg-secondary/30",
        tertiary: "border-transparent bg-tertiary/20 text-tertiary-foreground border-tertiary hover:bg-tertiary/30",
        destructive: "border-transparent bg-destructive/20 text-destructive border-destructive hover:bg-destructive/30",
        success: "border-transparent bg-success/20 text-success-foreground border-success hover:bg-success/30",
        outline: "text-foreground border-border hover:bg-muted",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
